import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material';
import { TermsPrivacyComponent } from './terms-privacy/terms-privacy.component';
import { TermsPrivacyService } from 'src/app/services/terms-priavcy.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  _terms;
  _policy;
  NoSession = true;
  footerData = [
    {
      title: 'Company',
      links : [
        {
          name : 'About Us',
          url : '/about-us',
          externalLink: false,
          function: false
        },
        // {
        //   name : 'Careers',
        //   url : 'https://angel.co/company/apiplatform-io/jobs',
        //   externalLink: true,
        //   function: false
        // },
        {
          name : 'Contact Us',
          url : '/contact-us',
          externalLink: false,
          function: false
        },
        {
          name : 'Privacy Policy',
          url : '/privacy-policy',
          externalLink: false,
          function: false
        },
        {
          name : 'Terms of Service',
          url : '/terms-of-service',
          function: false,
          externalLink: false
        }
      ]
    },
    {
      title: 'Create',
      links : [
        {
          name : 'Workflow',
          url : '/create',
          fragment: 'c4',
          function: false
        },
        {
          name : 'Business Logic',
          url : '/create',
          fragment: 'c2',
          function: false
        },
        // {
        //   name : 'Decision',
        //   url : '',
        //   function: false
        // },
        {
          name : 'SQL Query API',
          url : '/create',
          fragment: 'c3',
          function: false
        },
        {
          name : 'Data Access Service',
          url : '/create',
          fragment: 'c1',
          function: false
        }
      ]
    },
    {
      title: 'Integrate',
      links : [
        {
          name : 'Service Providers',
          url : '/integrate',
          fragment: 'i1',
          function: false
        },
        {
          name : 'Service Categories',
          url : '/integrate',
          fragment: 'i2',
          function: false
        }
      ]
    },
    {
      title: 'Transform',
      links : [
        {
          name : 'From Database',
          // url : '/transform#1',
          url : '/transform',
          fragment: 't1',
          function: false
        },
        {
          name : 'From API',
          url : '/transform',
          fragment: 't2',
          function: false
        },
        {
          name : 'From Open Spec',
          url : '/transform',
          fragment: 't3',
          function: false
        },
        {
          name : 'From BPMN',
          url : '/transform',
          fragment: 't4',
          function: false
        },
        // {
        //   name : 'From DMN',
        //   url : '',
        //   function: false
        // }
      ]
    },
    {
      title: 'Manage',
      links : [
        {
          name : 'Smart Control Plane',
          url : '/manage',
          fragment: 'm1',
          function: false
        },
        {
          name : 'API Gateway',
          url : '/manage',
          fragment: 'm2',
          function: false
        },
        {
          name : 'Developer Experience',
          url : '/manage',
          fragment: 'm3',
          function: false
        },
      ]
    }
  ];

  socialIconData  = [
    {
      name : 'linkedin',
      svg : './assets/linkedin.svg',
      link : 'https://www.linkedin.com/company/apiplatform-io'
    },
    {
      name : 'facebook',
      svg : './assets/facebook.svg',
      link : 'https://www.facebook.com/apiplatform.io'
    },
    {
      name : 'twitter',
      svg : './assets/twitter.svg',
      link : 'https://twitter.com/linxapiplatform'
    },
    {
      name : 'instagram',
      svg : './assets/instagram.svg',
      link : 'https://www.instagram.com/apiplatform.io/'
    },
    {
      name : 'youtube',
      svg : './assets/youtube.svg',
      link : 'https://www.youtube.com/channel/UCVgCJoYELVowFL-cS5WIHzQ'
    }
  ];
  constructor(
    private _bottomSheet: MatBottomSheet,
    private termsPrivacyService: TermsPrivacyService
  ) {}

  ngOnInit() {
    if (localStorage.getItem('Auth' ) === 'true') {
      this.NoSession = false;
    }
    this.termsPrivacyService
      .getTerms()
      .subscribe(value => {this._terms = value;});

    this.termsPrivacyService.getPrivacy().subscribe(response => {this._policy = response;});
  }
  _openTermsPrivacySheet(type: string) {
    if (type == 'privacy') {
        this._bottomSheet.open(TermsPrivacyComponent, { data: this._policy });
    } else {
      // terms
      this._bottomSheet.open(TermsPrivacyComponent, { data: this._terms });
    }

  }
}
